import { Button } from '@shared/components/ui/button';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface CreateOrderButtonProps {
  /** Si true, aplica estilos para estar dentro de EmptyView */
  inline?: boolean;
}

/**
 * Componente para el botón de crear pedido
 * Maneja la navegación y permisos de creación
 * Puede usarse arriba (con posicionamiento) o dentro de EmptyView
 */
export const CreateOrderButton = ({ inline = false }: CreateOrderButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('ordersModule');
  const { canAccess } = usePermissions();

  // Verificar si el usuario puede crear pedidos
  const canCreate = canAccess(['tenant', 'tenant_3pl', 'tenant_external'], ['orders.create']);

  // Si no tiene permisos, no mostrar el botón
  if (!canCreate) {
    return null;
  }

  return (
    <Button variant="primary" size="lg" onClick={() => navigate('/orders/create')} data-testid="create-order-button">
      {t('buttons.create')}
    </Button>
  );
};
